export default [
  {
    title: 'Sobre a JBCred',
    text: `A JBCred é uma sociedade de crédito, financiamento e investimento que atua há mais de 20 anos, oferecendo crédito de forma segura e transparente.`,
  },
  {
    title: 'Como funciona o empréstimo pessoal com a JBCred?',
    text: `
      <ul>
        <li>Você receberá o dinheiro em sua conta em até 1 dia útil.</li>
        <li>Você pode começar a pagar em até 30 dias.</li>
        <li>Aceitam pessoas de 22 a 80 anos.</li>
        <li>Aceitam também clientes com restrições no nome (negativados).</li>
      </ul>
    `,
  },
  {
    title: 'Quais são as etapas de solicitação?',
    text: `
     É super simples!
      <ol>
        <li>Após clicar em "Simular", você será redirecionado para o site da JBCred, onde será necessário preencher alguns dados.</li>
        <li>Prossiga com sua solicitação fornecendo informações como RG, CPF, comprovante de residência, holerites e extratos bancários dos últimos 60 dias. Em caso de trabalhador CLT, também será necessário fornecer uma cópia da carteira de trabalho.</li>
        <li>Aguarde a análise e você receberá o dinheiro em sua conta em até 1 dia útil.</li>
      </ol>
      <br />
      É só enviar todos os dados e seguir o que se pede. Após concluir essa primeira etapa, você precisará baixar o aplicativo da parceira para dar continuidade.
    `,
  },
  {
    title: 'Qual a documentação necessária para contratar?',
    text: `
      As documentações necessárias são:
      <ul>
        <li>RG e CPF</li>
        <li>Comprovante de residência</li>
        <li>Comprovante de renda: holerites ou extratos bancários de 60 dias</li>
        <li>Em caso de CLT, a cópia da carteira de trabalho será solicitada</li>
      </ul>
    `,
  },
  {
    title: `Quais são os requisitos para pedir um empréstimo?`,
    text: `Para prosseguir com a contratação, é necessário ter um CPF válido e ser maior de 22 anos. Siga as orientações fornecidas no site da nossa parceira para dar continuidade ao processo.`,
  },
  {
    title: `Em quanto tempo vou receber o dinheiro na minha conta bancária?`,
    text: `O prazo para pagamento é de 1 dia útil após a aprovação da sua oferta.`,
  },
]
